import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { Container, Row, Col, Card, Form, Button, InputGroup, Pagination } from "react-bootstrap";
import BlogCard from "./BlogCard";

const AllBlogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const loggedInUser = useSelector((state) => state.auth.user);
  const token = loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const fetchAllBlogs = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/all/blogs`,
        {
          page_number: currentPage,
          page_size: 20,
          order_by: "ASC",
          keyword_search: searchKeyword,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log("Response from fetchAllBlogs:", response.data); // Debugging line

      if (response.data.statusType === "SUCCESS") {
        setBlogs(response.data.blogs);
        setTotalPages(response.data.total_pages || 1);
      } else {
        console.error("Failed to fetch all blogs");
      }
    } catch (error) {
      console.error("Error fetching all blogs:", error);
    }
  };

  useEffect(() => {
    fetchAllBlogs();
  }, [currentPage]);

  const handleSearch = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    fetchAllBlogs();
  };

 

  return (
    <Container className="my-4">
      <h2 className="mb-4 text-center">All Blogs</h2>

      {/* Search Box */}
      <Form onSubmit={handleSearch} className="mb-4">
        <InputGroup>
          <Form.Control
            type="text"
            placeholder="Search blogs..."
            value={searchKeyword}
            onChange={(e) => setSearchKeyword(e.target.value)}
          />
          <Button variant="primary" type="submit">
            Search
          </Button>
        </InputGroup>
      </Form>

      {/* Blog Cards */}
      <Row>
        {blogs.map((blog) => (
          <Col key={blog._id} md={4}>
            <BlogCard
              title={blog.title}
              description={blog.excerpt}
              imageUrl={blog.image_url}
              blogId={blog.id}
              author={blog.author}
              date={blog.publish_date}
              tags={blog.tags}
              slug={blog.slug}
            />
          </Col>
        ))}
      </Row>
      
      {/* Pagination */}
      <div className="d-flex justify-content-center mt-4">
        <Pagination>
          <Pagination.Prev
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
          />
          <Pagination.Item active>{currentPage}</Pagination.Item>
          <Pagination.Next
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
          />
        </Pagination>
      </div>
    </Container>
  );
};

export default AllBlogs;
